module.exports = __webpack_public_path__ + "static/media/costcontrol3.9f9e7e11.png";